import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  ViewMotor,
  ViewSchedule, ViewVehicle, ViewVehicleMaintenance, ViewVehicleSchedule
} from '../models/constant/right';
import { VehicleComponent } from './vehicle/vehicle.component';
import { FleetComponent } from './fleet.component';
import { VehicleDetailComponent } from './vehicle-detail/vehicle-detail.component';
import { ScheduleDetailComponent } from './schedule-detail/schedule-detail.component';
import { VehicleMaintenanceDetailComponent } from './vehicle-maintenance-detail/vehicle-maintenance-detail.component';
import { VehicleScheduleDetailComponent } from './vehicle-schedule-detail/vehicle-schedule-detail.component';
import { MotorComponent } from './motor/motor.component';
import { canActivateRoute } from '../services/permission.service';
import { PendingChangesGuard } from '../shared/candeactivate.guard';
import { DvirDetailComponent } from './dvir-detail/dvir-detail.component';

const routes: Routes = [
  {
    path: '',
    component: FleetComponent,
    canActivate: [canActivateRoute],
    data: {
      rights: [ ViewVehicle ]
    },
    children: [
      {
        path: '',
        redirectTo: 'vehicle',
        pathMatch: 'full'
      },
      {
        path: 'vehicle',
        component: VehicleComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewVehicle]
        }
      },
      {
        path: 'vehicle/:id',
        component: VehicleDetailComponent,
        canActivate: [canActivateRoute],
        canDeactivate: [PendingChangesGuard],
        data: {
          rights: [ViewVehicle]
        }
      },
      {
        // Legacy link shape emitted by fleet-hd-subscriber-schedule-function
        path: 'vehicledetail/:id',
        redirectTo: 'vehicle/:id'
      },
      {
        path: 'vehicle/:vin/maintenance',
        component: VehicleMaintenanceDetailComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewVehicleMaintenance]
        }
      },
      {
        path: 'vehicle/:vin/maintenance/:id',
        component: VehicleMaintenanceDetailComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewVehicleMaintenance]
        }
      },
      {
        path: 'vehicle/:vin/schedule/:id',
        component: VehicleScheduleDetailComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewVehicleSchedule]
        }
      },
      {
        path: 'dvir/:id',
        component: DvirDetailComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewVehicle]
        }
      },
      {
        path: 'schedule/:id',
        component: ScheduleDetailComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewSchedule]
        }
      },
      {
        path: 'motor',
        component: MotorComponent,
        canActivate: [canActivateRoute],
        data: {
          rights: [ViewMotor]
        }
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FleetRoutingModule { }
